/**
 * kitcond-hide-impressao.js
 * ------------------------------------------------------------
 * Esconde a opção "Impressão" na UI do variant picker quando:
 * - "Cores Personalização" não tem valor selecionado, OU
 * - "Cores Personalização" = "Sem Personalização"
 *
 * Edite só o CONFIG abaixo se os nomes das opções mudarem.
 * ------------------------------------------------------------
 */
(function kitcondHideImpressao() {
  // ===== CONFIG (edite aqui) =====
  var CONFIG = {
    watchOptionName: 'Número de Cores',
    hideWhenValue: 'Sem Personalização',
    hideOptionName: 'Tipo de Personalização',
    /** Se true, também esconde Impressão enquanto Cores Personalização estiver sem seleção */
    hideWhenNothingSelected: true,
    hiddenClass: 'kitcond-variant-option--hidden',
  };
  // ===== fim CONFIG =====

  function norm(str) {
    return String(str || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function findFieldsetByOptionName(picker, optionName) {
    var want = norm(optionName);
    var fieldsets = picker.querySelectorAll('fieldset.hdt-product-form__input');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var input = fs.querySelector('input[type="radio"], select');
      if (input && norm(input.name) === want) return fs;
    }
    return null;
  }

  function getSelectedValue(fieldset) {
    if (!fieldset) return '';
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var select = fieldset.querySelector('select');
    if (select) return select.value;
    return '';
  }

  function ensureHiddenDefault(fieldset) {
    if (!fieldset || getSelectedValue(fieldset)) return;
    var first = fieldset.querySelector('input[type="radio"]');
    if (first) first.checked = true;
  }

  function setFieldsetHidden(fieldset, hide) {
    if (!fieldset) return;
    if (hide) {
      fieldset.classList.add(CONFIG.hiddenClass);
      fieldset.setAttribute('hidden', '');
      fieldset.setAttribute('aria-hidden', 'true');
      ensureHiddenDefault(fieldset);
    } else {
      fieldset.classList.remove(CONFIG.hiddenClass);
      fieldset.removeAttribute('hidden');
      fieldset.removeAttribute('aria-hidden');
    }
  }

  function syncPicker(picker) {
    if (!picker || !picker.isConnected) return;
    var watchFs = findFieldsetByOptionName(picker, CONFIG.watchOptionName);
    var hideFs = findFieldsetByOptionName(picker, CONFIG.hideOptionName);
    if (!watchFs || !hideFs) return;

    var selected = getSelectedValue(watchFs);
    var nothingSelected = !selected;
    var isHideValue = norm(selected) === norm(CONFIG.hideWhenValue);
    var shouldHide =
      isHideValue || (CONFIG.hideWhenNothingSelected && nothingSelected);

    setFieldsetHidden(hideFs, shouldHide);
  }

  function syncAll() {
    document.querySelectorAll('hdt-variant-picker').forEach(syncPicker);
  }

  function onChange(event) {
    var input = event.target;
    if (!input || !input.name) return;
    if (norm(input.name) !== norm(CONFIG.watchOptionName)) return;
    var picker = input.closest('hdt-variant-picker');
    if (picker) syncPicker(picker);
  }

  document.addEventListener('change', onChange, true);

  if (typeof MutationObserver !== 'undefined') {
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncAll();
      });
    }
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('shopify:section:reorder', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
